import React from "react";

type MultimediaGridProps = {
  data: {
    type: string;
    heading: string;
    items: {
      name: string;
      icon: string;
      color: string;
    }[];
  };
};

const MultimediaGrid: React.FC<MultimediaGridProps> = ({ data }) => {
  // const Translate = useTranslator("common");

  

  return (
    <div className="relative bg-aurora1 p-4 md:py-12">
      {/* <Gradient
        type="aurora2"
        className="z-hidden absolute -left-1 -top-20"
        width="2000px"
        height="2000px"
        opacity="50"
      /> */}
      <h2 className="font-obviously mb-10 whitespace-pre-wrap text-center text-title-32 text-black md:text-3xl ">
        {data.heading}
      </h2>
      <div
        className={`flex flex-wrap gap-2 md:gap-10 ${
          data?.items?.length > 8 || data?.items?.length < 6
            ? "max-w-6xl"
            : "max-w-4xl"
        } md:mx-auto max-w-4xl items-center justify-center`}
      >
        {data?.items?.map(({ name, icon, color }, index) => (
          <div
            key={name}
            className="relative flex h-40 w-40 items-center justify-center rounded-md bg-white"
            style={{
              boxShadow: "0px 0px 25px rgba(196, 207, 255, 0.25)",
            }}
          >
            <div
              className={`${color} absolute left-12 top-7 z-0 h-8 w-8 rounded-full opacity-80`}
            />
            <div className="relative z-10 flex flex-col items-center justify-center">
              <img
                src={icon}
                alt="multimedia icon"
                className="h-6 w-7 md:h-10 md:w-11"
              />
              <h3 className=" text-title-14 mt-6 text-center">
                {name}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default MultimediaGrid;
